import React, { useEffect } from 'react';

import MetaTags from 'react-meta-tags';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { MCCard } from '../../components/mc';

import useTranslation from '../../hooks/useTranslation';
import { fetchProfileData } from '../../store/actions';
import '../Authentication/scss/profile.scss';
import s from './UserProfileSetting.module.scss';
import { BaseInfoSetting, NotificationsSetting, PasswordSetting } from './components';

const UserProfileSetting = () => {
  const dispatch = useDispatch();
  const t = useTranslation();

  useEffect(() => {
    dispatch(fetchProfileData());
  }, [dispatch]);

  return (
    <React.Fragment>
      <MetaTags>
        <title>{t('user_profile_meta_title')}</title>
      </MetaTags>
      <div className={s.container}>
        <div className={s.wrapper}>
          <MCCard pad="lg" className={s.settingBlockWrapper}>
            <BaseInfoSetting />
          </MCCard>
          <div className={s.settingGroupWrapper}>
            <MCCard pad="lg">
              <PasswordSetting />
            </MCCard>
            <MCCard pad="lg">
              <NotificationsSetting />
            </MCCard>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfileSetting);
